module.exports = __webpack_public_path__ + "media/images/stanfordwhite-89dddbbb29b9065194a289e850445c8d.svg";